import React from 'react';
import { BrowserView } from 'react-device-detect';
import { Link } from 'react-router-dom';

import Plano from 'Interface/Planos';

interface Props {
    dados: Plano;
    acoes?: boolean;
}

export const PlanoLista = ({ dados }: Props): React.ReactElement =>
(
    <div className="d-flex border-bottom align-items-center justify-content-between py-2 px-3">
        <div className="fs-4">
            <Link
                to={ `/admin/planos/editar/${dados.id}` }
                className="text-decoration-none"
            >
                { dados.nome }
            </Link>
            <small className="d-block fs-6 text-muted">
                Nome
            </small>
        </div>
        <div className="d-flex align-items-center">
            <div className="ms-5 fs-5">
                { dados.valor.moeda() }
                <small className="d-block fs-6 text-muted">
                    Valor
                </small>
            </div>
            <BrowserView>
                <div className="ms-5 fs-5">
                    { dados.criado.data().toLocaleString() }
                    <small className="d-block fs-6 text-muted">
                        Criado em
                    </small>
                </div>
            </BrowserView>
        </div>

    </div>
)
